import * as React from "react";
import { GlobeIcon } from "lucide-react";
import { useQueryClient } from "@tanstack/react-query";
import { useCurrentLocale, useChangeLocale } from "@/locales/client";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
const locales = process.env.NEXT_PUBLIC_LOCALES?.split(",") as ["en", "de"];

// ... imports remain the same ...

export function LocaleSwitch({
  isTransparent
}: {
  isTransparent?: boolean;
}) {
  const currentLocale = useCurrentLocale();
  const changeLocale = useChangeLocale();
  const queryClient = useQueryClient();
  const handleLocaleChange = (value: string) => {
    changeLocale(value as "en" | "de");
  };
  return <Select aria-label="Select language" value={currentLocale} onValueChange={handleLocaleChange} data-sentry-element="Select" data-sentry-component="LocaleSwitch" data-sentry-source-file="LocaleSwitch.tsx">
      <SelectTrigger aria-label={`Current language: ${currentLocale.toUpperCase()}`} className={`w-fit bg-transparent transition-colors ${isTransparent ? "text-white" : ""}`} data-sentry-element="SelectTrigger" data-sentry-source-file="LocaleSwitch.tsx">
        <GlobeIcon aria-hidden="true" className="mr-2 h-4 w-4" data-sentry-element="GlobeIcon" data-sentry-source-file="LocaleSwitch.tsx" />
        <SelectValue placeholder={currentLocale.toUpperCase()} data-sentry-element="SelectValue" data-sentry-source-file="LocaleSwitch.tsx" />
      </SelectTrigger>
      <SelectContent className="min-w-0" data-sentry-element="SelectContent" data-sentry-source-file="LocaleSwitch.tsx">
        {locales.map(locale => <SelectItem key={locale} aria-label={`Switch to ${locale === "en" ? "English" : "German"}`} value={locale}>
            {locale.toUpperCase()}
          </SelectItem>)}
      </SelectContent>
    </Select>;
}